export default "__VITE_ASSET__Do04aDcE__"